export default {
  suppressions: state => state.suppressions
}
